import React from 'react';
import { CTAButton, CHECKOUT_URL, PRICE, PRICE_SHORT, Section } from './Shared';
import { Blossom, DropperBottle, Sprig } from './Decor';
export function EmotionalClose() {
  return <Section className="max-w-4xl" data-id="element-61" data-mp="vmcunboj9mf0">
      <div className="relative overflow-hidden rounded-3xl bg-brand-taupe p-6 text-center text-brand-cream md:p-12" data-id="element-62" data-mp="vlbbsl19zvmq">
        <Blossom aria-hidden="true" className="pointer-events-none absolute -left-6 -top-6 h-32 w-32 text-white/15" data-id="element-63" data-mp="qmqil5kfyc7s" />
        <Sprig aria-hidden="true" className="pointer-events-none absolute -bottom-8 -right-4 h-48 w-28 text-white/15" data-id="element-64" data-mp="mjlkdf7e8woy" />
        <DropperBottle aria-hidden="true" className="pointer-events-none absolute bottom-4 left-6 hidden h-32 w-16 text-brand-goldLight/20 md:block" data-id="element-65" data-mp="cnikyh3xfc5p" />
        <div className="relative" data-id="element-66" data-mp="7ppavczi5y05">
          <h2 className="mb-6 font-serif text-2xl font-bold leading-tight text-brand-goldLight md:text-4xl" data-id="element-67" data-mp="7qs4vts4ggka">
            🌿 Tu próxima tandada comienza con sistema, no con improvisación
          </h2>
          <div className="mx-auto mb-10 max-w-2xl space-y-4 text-base leading-relaxed text-brand-cream/90 md:text-lg" data-id="element-68" data-mp="220m1mpegv54a">
            <p data-id="element-69" data-mp="3a1c5qcpo3er4">La pregunta no es si podés pagarlo.</p>
            <p className="font-semibold text-white" data-id="element-70" data-mp="3a2x3eb7a3dt7">
              La pregunta es cuántas tandadas más vas a fabricar sin una estructura que te respalde.
            </p>
            <p className="pt-2" data-id="element-71" data-mp="304h9y1ks3sgj">Hay dos versiones de vos en este momento.</p>
            <p data-id="element-72" data-mp="3nsh1h3pwzmw6">
              Una que cierra esta página y sigue improvisando. Sigue cobrando lo mismo. Sigue viendo a otras ganar
              dinero con productos que vos también sabés hacer.
            </p>
            <p className="font-display text-lg italic text-brand-goldLight md:text-xl" data-id="element-73" data-mp="3e3z3svcxlvwr">
              Y otra que decide que hoy es el día en que su negocio de cosmética natural cambia para siempre.
            </p>
          </div>

          <div className="mx-auto max-w-md rounded-2xl border-2 border-brand-gold/60 bg-white p-6 shadow-[0_10px_30px_rgba(44,44,44,.2)]" data-id="element-74" data-mp="akxj77apovzb">
            <span className="relative -top-9 inline-block rounded-full bg-brand-gold px-3 py-1 text-xs font-bold text-brand-taupeDeep" data-id="element-75" data-mp="p977ei4ljxvn">
              ⭐ MÁS ELEGIDO
            </span>
            <h3 className="-mt-4 font-serif text-xl font-bold text-brand-taupe" data-id="element-76" data-mp="k89t4gmpjnzf">🌿 COSMÉTICA NATURAL</h3>
            <p className="my-2 text-4xl font-bold text-brand-taupe" data-id="element-77" data-mp="gac4bewun3wk">{PRICE}</p>
            <p className="mb-5 text-sm leading-relaxed text-brand-muted" data-id="element-78" data-mp="b94xpj6g0arh">
              3 Tomos + 6 Bonus · Más de 300 páginas. Recetarios, ingeniería de precios, branding magnético y guiones
              de venta. Acceso de por vida.
            </p>
            <CTAButton href={CHECKOUT_URL} variant="gold" fullWidth className="text-sm md:text-base" data-id="element-79" data-mp="3spe9wlb9zp2u">
              QUIERO ACCESO YA — {PRICE_SHORT} →
            </CTAButton>
            <p className="mt-4 text-[11px] text-brand-muted" data-id="element-80" data-mp="3jp81veycjhb2">
              ✓ Acceso inmediato · ✓ 100% PDF · ✓ Garantía 7 días · ✓ Pago seguro
            </p>
          </div>

          <p className="mt-8 text-sm text-brand-cream/85 md:text-base" data-id="element-81" data-mp="3es7wl69bmil0">
            El precio de lanzamiento vence hoy. Después sube. No vuelve.
          </p>
        </div>
      </div>
    </Section>;
}